import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveSnowOptionsFromSKU as resolveOptionsFromSKU,
} from './shared.mjs'
import strap from './shared-straps.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    whiteM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_whiteM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_whiteM-{nnn}.png',
    },
    beigeM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_beigeM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_beigeM-{nnn}.png',
    },
    blackM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_blackM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_blackM-{nnn}.png',
    },
    greyM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_greyM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_greyM-{nnn}.png',
    },
    rustM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_rustM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_rustM-{nnn}.png',
    },
    purpleM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_purpleM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_purpleM-{nnn}.png',
    },
    tealM: {
      pathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_tealM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/ullrs/frame2/ulf_tealM-{nnn}.png',
    },
    neonyellowM: {
      pathTemplate: 'gs://sg360/261019/uf_chaos-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/uf_chaos-{nnn}.png',
    },
    sageM: {
      pathTemplate: 'gs://sg360/261019/ulf_sageM-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/ulf_sageM-{nnn}.png',
    },
    none: {
      pathTemplate: 'gs://sg360/251217/ghost/ulf_ghost-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/ghost/ulf_ghost-{nnn}.png',
    },
  },
}

export const lens = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    silverblueN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_silverblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_silverblueN-{nnn}.png',
    },
    silverblue8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8silverblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8silverblueN-{nnn}.png',
    },
    fireN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_fireN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_fireN-{nnn}.png',
    },
    fire8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8fireN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8fireN-{nnn}.png',
    },
    clearN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_clearN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_clearN-{nnn}.png',
    },
    clear8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8clearN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8clearN-{nnn}.png',
    },
    greenN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_greenN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_greenN-{nnn}.png',
    },
    green8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8greenN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8greenN-{nnn}.png',
    },
    purpleN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_purpleN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_purpleN-{nnn}.png',
    },
    purple8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8purpleN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8purpleN-{nnn}.png',
    },
    goldN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_goldN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_goldN-{nnn}.png',
    },
    gold8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8goldN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8goldN-{nnn}.png',
    },
    pinkN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_pinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_pinkN-{nnn}.png',
    },
    pink8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8pinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8pinkN-{nnn}.png',
    },
    smokeN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_smokeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_smokeN-{nnn}.png',
    },
    smoke8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8smokeN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8smokeN-{nnn}.png',
    },
    hvblueN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_hvblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_hvblueN-{nnn}.png',
    },
    hvblue8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8hvblueN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8hvblueN-{nnn}.png',
    },
    hvpinkN: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_hvpinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_hvpinkN-{nnn}.png',
    },
    hvpink8N: {
      pathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8hvpinkN-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/final-v2/ullrs/ule_8hvpinkN-{nnn}.png',
    },
    none: {
      pathTemplate: 'gs://sg360/251217/ghost/ule_ghost-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/ghost/ule_ghost-{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: getSKUWithoutPrefix(customisedProduct.frameChoice?.sku),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice?.sku),
    strap: getSKUWithoutPrefix(customisedProduct.strapChoice?.sku),
  }
}

export default {
  layers: [strap, frame, lens],
  resolveOptions,
  resolveOptionsFromSKU,
}
